import React from 'react'
import PropTypes from 'prop-types'
import { Calendar } from 'react-date-range'
import {
  BOX2HOME_PRIMARY_COLOR,
  locale,
  localeMap,
} from '../../../../../utils/values'

export default function RangePicker({ state, setState }) {
  return (
    <Calendar
      onChange={(item) => setState(item)}
      locale={localeMap[locale]}
      moveRangeOnFirstSelection={false}
      date={state}
      direction="horizontal"
      staticRanges={[]}
      rangeColors={[BOX2HOME_PRIMARY_COLOR, '#ffffff', BOX2HOME_PRIMARY_COLOR]}
    />
  )
}
RangePicker.propTypes = {
  state: PropTypes.instanceOf(Date),
  setState: PropTypes.func,
}
